'use client';

import { useShareResult } from '@/lib/gameShare';
import { getScoreSegments } from '../lib/score';

interface ShareButtonProps {
  date: string;
  score: number;
  makePoints: number;
  modelPoints: number;
  genPoints: number;
  streak?: number;
}

function formatDate(isoDate: string): string {
  const d = new Date(isoDate + 'T12:00:00'); // noon to avoid timezone issues
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function ShareButton({
  date,
  score,
  makePoints,
  modelPoints,
  genPoints,
  streak,
}: ShareButtonProps) {
  const { make, model, gen, unaccounted, missed } = getScoreSegments(
    score,
    makePoints,
    modelPoints,
    genPoints,
  );
  const bar =
    '🟩'.repeat(make + unaccounted) +
    '🟦'.repeat(model) +
    '🟪'.repeat(gen) +
    '⬛'.repeat(missed);
  const lines = [
    `Daily Carspotting · Name The Car — ${formatDate(date)}`,
    `${bar} ${score}/9`,
  ];
  if (streak && streak >= 2) {
    lines.push(`🔥 ${streak}-day streak`);
  }
  lines.push(`https://namethecar.com/${date}`);
  const shareText = lines.join('\n');

  const { share, copied } = useShareResult('spot', shareText);

  return (
    <button
      onClick={share}
      className="bg-denim hover:bg-denim/90 w-full rounded-lg py-2.5 text-sm font-medium text-white shadow-sm transition"
    >
      {copied ? 'Copied!' : 'Share your score'}
    </button>
  );
}
